module.exports = __webpack_public_path__ + "img/icon_red_right.af83513d.svg";